/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  InstituteRoomBadge,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    InstituteRoomBadgeFromJSON,
    InstituteRoomBadgeToJSON,
} from '../models/index';

/**
 * 
 */
export class InstituteRoomBadgeApi extends runtime.BaseAPI {

    /**
     * Lists all active room badges
     */
    async listInstituteRoomBadgeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InstituteRoomBadge>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institute-room-badges`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InstituteRoomBadgeFromJSON));
    }

    /**
     * Lists all active room badges
     */
    async listInstituteRoomBadge(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InstituteRoomBadge>> {
        const response = await this.listInstituteRoomBadgeRaw(initOverrides);
        return await response.value();
    }

}
